import React, { useEffect, useState } from 'react';
import SelectSingle from './SelectSingle';
import Progress from './Progress';
import { useSnackbar } from 'notistack';
import usersService from '../../services/users';

export type UserReference = {
  id: number;
  firstName?: string | null;
  lastName?: string | null;
};

interface Props {
  value: { id: string | undefined } | undefined;
  onChange: (user: UserReference | undefined) => void;
}

const userSort = (a: UserReference, b: UserReference) => (a.lastName || '').localeCompare(b.lastName || '');

const SelectSingleUser: React.FunctionComponent<Props> = (props) => {
  const [users, setUsers] = useState<UserReference[] | null>(null);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    usersService.getUsers({ limit: 100000 }).then(
      (result: { items: UserReference[] }) => setUsers(result.items.slice().sort(userSort)),
      () => enqueueSnackbar('Failed to load users', { variant: 'error', autoHideDuration: 3000 })
    );
  }, [enqueueSnackbar]);

  if (!users) {
    return <Progress />;
  }

  const selected = users.find((user) => String(user.id) === (props.value && props.value.id));

  return (
    <SelectSingle<UserReference>
      selected={selected}
      onChange={props.onChange}
      data={users}
      isClearable={true}
      label="User"
      placeholder="Select User"
      optionValue={(option) => String(option.id)}
      optionLabel={(option) => option.lastName + ', ' + option.firstName}
    />
  );
};

export default SelectSingleUser;
